function HeroBanner() {
    return (
      <section className="h-screen bg-gray-900 flex items-center justify-center">
        {/* Replace with your actual video or collage */}
        <video src="/NohaVideo.mp4" autoPlay loop muted className="w-full h-full object-cover" />
      </section>
    );
  }
 
  export default HeroBanner;